// src/components/layout/Modals/AddPatientModal/patientDataDefaults.ts

import { Patient } from '@dataTypes/PatientInfo.types'

export const defaultPatientData: Patient = {
  patient_id: '',
  title: '',
  first_name: '',
  middle_name: '',
  last_name: '',
  city: '',
  state: '',
  zip: '',
  preferred_name: '',
  date_of_birth: '',
  address: '',
  gender: '',
  marital_status: '',
  profession: '',
  company_name: '',
  cellphone: '',
  email: '',
  home_phone: '',
  work_phone: '',
  fax_number: '',
  allergy_ids: [],
  medical_condition_ids: [],
  patient_allergies: [],
  patient_medical_conditions: [],
  insurance_provider: '',
  policy_number: '',
  insurance_expiry_date: '',
  family_members: '',
  referral_source: 0,
  join_referral_program: false,
  preferred_appointment_time: '',
  contact_via_phone: false,
  contact_via_sms: false,
  contact_via_email: false,
  contact_via_app: false,
  has_insurance: false,
  preferred_provider: '',
  preferred_hygienist: '',
  notes: '',
  uploadedFiles: [],
  template: '',
  contact_via: [],
  patient_status: 34,
}
